"use client";

import {
  MoreVertical,
  ArrowRight,
  ArrowDownToLine,
  ArrowUpFromLine,
  Plus,
  ArrowUp,
} from "lucide-react";
import {
  useProductHistory,
  useUserTransactionHistory,
} from "../hooks/query/queries";
import { Button } from "./ui/button";

import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { ToggleGroup, ToggleGroupItem } from "./ui/toggle-group";
import { useEffect, useState } from "react";
import { Skeleton } from "./ui/skeleton";
import TransactionHistoryAll from "./TransactionHistoryAll";
import TransactionHistorySingle from "./TransactionHistorySingle";
import withdrawIcon from "../assets/images/withdrawaIcon.svg";
import CurrencyFormatter from "../utils/currencyFormatter";
import buyIcon from "../assets/images/buyIcon.svg";
import sendIcon from "../assets/images/sendIcon.svg";
import zarDeposit from "../assets/images/zarDeposit.svg";
import sellIcon from "../assets/images/sellIcon.svg";
import receiveIcon from "../assets/images/receiveIcon.svg";
import InvestTransactionHistorySingle from "./InvestTransactionHistorySingle";
import InvestTransactionHistoryAll from "./InvestTransactionHistoryAll";
import TransactionDate from "./DateFormmatter";
import { FormattedDate } from "../utils/dateFormatter";

const filters = {
  UserTrade: "Buy/Sell",
  FiatTransaction: "Deposit/Withdrawal",
  Payment: "80eightPay",
  CryptoTransaction: "Send/Receive",
};

export function InvestProductHistory({ userId, ledgerId, asset }) {
  const [filter, setFilter] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [allTransactions, setAllTransactions] = useState([]);
  const [selectedTransaction, setSelectedTransaction] = useState([]);
  const [singleTransaction, setSingleTransaction] = useState(false);
  const [transactionsAll, setTransactionsAll] = useState(false);
  const [isFromAllTr, setIsFromAllTr] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const {
    data: transactionsComplete,
    isLoading,
    isError,
    errorTr,
  } = useProductHistory(ledgerId);
  console.log("transactionsComplete", transactionsComplete);
  const transactionHistory = transactionsComplete?.results;

  const formatter = new CurrencyFormatter();

  const handleOpenTHModal = () => {
    setTransactionsAll(true);
  };

  const handleReOpenTHModal = () => {
    if (isFromAllTr) {
      setTransactionsAll(true);
    }
  };

  const handleSingleTransaction = (order) => {
    setIsFromAllTr(false);
    setSelectedTransaction(order);
    setSingleTransaction(true);
    setTransactionsAll(false);
  };
  const dateFormat = new FormattedDate();
  return (
    <Card className="col-span-2 flex flex-col">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Transaction history</CardTitle>
      </CardHeader>
      <CardContent className="p-0 flex-1 flex flex-col">
        <div className="space-y-6 p-6 flex-1">
          {isLoading ? (
            Array.from({ length: 3 }).map((_, index) => (
              <div
                key={index}
                className="flex items-center gap-8 py-2 animate-pulse"
              >
                <div className="flex items-center gap-4">
                  <Skeleton className="h-12 w-12 rounded-full bg-gray-300" />
                  <div className="space-y-2">
                    <Skeleton className="h-4 w-24 bg-gray-300" />
                    <Skeleton className="h-3 w-20 bg-gray-300" />
                  </div>
                </div>
                <div className="flex items-center justify-end gap-24 flex-1">
                  <div className="flex items-center justify-left">
                    <div className="space-y-2">
                      <Skeleton className="h-4 w-16 bg-gray-300" />
                    </div>
                  </div>

                  <div className="flex items-center justify-center">
                    <Skeleton className="h-6 w-28 rounded-full bg-gray-300" />
                  </div>

                  <div className="flex items-center justify-end">
                    <Skeleton className="h-10 w-10 rounded-full bg-gray-300" />
                  </div>
                </div>
              </div>
            ))
          ) : transactionHistory ? (
            transactionHistory?.slice(0, 5)?.map((transaction) => (
              <div key={transaction?._id} className="flex items-center gap-8">
                <div className="flex items-center gap-4">
                  {transaction.type === "withdrawal" && (
                    <img src={withdrawIcon} alt="" />
                  )}
                  {transaction.type === "deposit" && (
                    <img src={zarDeposit} alt="" />
                  )}
                  {transaction.type === "payout" && (
                    <img src={receiveIcon} alt="" />
                  )}
                  <div>
                    <div className="text-gray-900 font-medium">
                      {transaction.type &&
                        transaction.type.charAt(0).toUpperCase() +
                          transaction.type.slice(1).toLowerCase()}
                    </div>
                    <div className="text-gray-500 text-sm">
                      {dateFormat.simpleFormat(transaction.createdAt)}
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-end gap-24 flex-1">
                  <div className="flex">
                    <div className="text-gray-900 font-bold">
                      {formatter.format(
                        transaction.amount,
                        asset?.toUpperCase()
                      )}
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    {transaction.status && (
                      <div
                        className={`flex items-center gap-2 ${
                          transaction.status === "successful"
                            ? "bg-green-50"
                            : transaction.status === "pending"
                              ? "bg-yellow-50"
                              : "bg-red-50"
                        } px-3 py-1 rounded-full`}
                      >
                        <div
                          className={`w-2 h-2 rounded-full ${
                            transaction.status === "successful"
                              ? "bg-green-500"
                              : transaction.status === "pending"
                                ? "bg-yellow-500"
                                : "bg-red-500"
                          }`}
                        />
                        <span
                          className={`text-sm ${
                            transaction.status === "successful"
                              ? "text-green-500"
                              : transaction.status === "pending"
                                ? "text-yellow-500"
                                : "text-red-500"
                          }`}
                        >
                          {transaction.status &&
                            transaction.status.charAt(0).toUpperCase() +
                              transaction.status.slice(1).toLowerCase()}
                        </span>
                      </div>
                    )}
                  </div>
                  <Button
                    onClick={() => handleSingleTransaction(transaction)}
                    variant="outline"
                    size="icon"
                    className="rounded-full"
                  >
                    <ArrowRight className="w-5 h-5 text-gray-500" />
                  </Button>
                </div>
              </div>
            ))
          ) : (
            <p>No transactions found.</p>
          )}
        </div>
        <Button
          onClick={handleOpenTHModal}
          variant="ghost"
          className="p-8 border-t w-full flex items-center justify-between group rounded-none hover:no-underline"
        >
          View all transaction history
          <div className="border p-2 rounded-full bg-transparent transition-transform group-hover:translate-x-1">
            <ArrowRight className="h-4 w-4" />
          </div>
        </Button>
        {singleTransaction && (
          <InvestTransactionHistorySingle
            selectedTransaction={selectedTransaction}
            openSingle={singleTransaction}
            setOpenSingle={setSingleTransaction}
            asset={asset}
            onClose={handleReOpenTHModal}
          />
        )}
        {transactionsAll && (
          <InvestTransactionHistoryAll
            transactionsComplete={transactionHistory}
            openAll={transactions}
            setOpenAll={setTransactionsAll}
            asset={asset}
            onOpenSingle={handleSingleTransaction}
            setIsFromAllTr={setIsFromAllTr}
          />
        )}
      </CardContent>
    </Card>
  );
}
